module.exports = __webpack_public_path__ + "public/files/img/meta.ba752c8f.png";